// Důvod ukončení a co dál se sales (15. 10. 2026, Láďa, schválený náhled).
// Používá potvrzení Ukončeno v kartě klientky i plánované ukončení. Hodnota:
// { duvod, poznamka, sales: "za3mesice" | "nevolat" | "ponechat" }. Při „Už jí nevolat“ je poznámka povinná
// (kromě ukončení „ne v dobrém“, kde okno UkonceniDialog přidává typ, spokojena a blacklist, 1. 11. 2026).
// 17. 10. 2026 (hlášení Kristiny): když už má klientka u sales naplánovaný hovor, okno ho
// ukáže místo „Za 3 měsíce“ (volba „ponechat“), aby vedle něj nevznikl druhý, dřívější hovor.
import React, { useEffect, useRef, useState } from "react";
import { apiFetch } from "../lib/api.js";

export const DUVODY_UKONCENI = [
  { key: "finance", label: "Finance" }, { key: "zdravi", label: "Zdravotní důvody" },
  { key: "cas", label: "Časové důvody" }, { key: "stehovani", label: "Stěhování, dojezd" },
  { key: "cil", label: "Splnila cíl" }, { key: "trener", label: "Nesedl trenér" },
  { key: "jinde", label: "Cvičí sama nebo jinde" }, { key: "jiny", label: "Jiný důvod" },
];
export const PRAZDNE_UKONCENI = { duvod: "", poznamka: "", sales: "za3mesice" };

/** Vrátí text chyby, nebo "" když je výběr v pořádku. */
export function chybaUkonceni(v) {
  if (!v?.duvod) return "Vyber, proč končí.";
  // 1. 11. 2026 (zadání 5): u ukončení „ne v dobrém“ je důvod nevolat jasný, poznámka je nepovinná (mockup 5A).
  if (v.sales === "nevolat" && v.typ !== "ne_v_dobrem" && !String(v.poznamka || "").trim()) return "Napiš do poznámky, proč už jí nevolat.";
  return "";
}

function datumZa3Mesice(konec) {
  const d = new Date(`${String(konec || new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Prague" })).substring(0, 10)}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + 91);
  return `${d.getUTCDate()}. ${d.getUTCMonth() + 1}. ${d.getUTCFullYear()}`;
}

const fmtIso = (iso) => { const [y, m, d] = String(iso).split("-").map(Number); return `${d}. ${m}. ${y}`; };

export default function UkonceniVolby({ value, onChange, konec, klientId = null, disabled = false }) {
  const v = value || PRAZDNE_UKONCENI;
  const set = (patch) => onChange({ ...v, ...patch });
  const [hovor, setHovor] = useState(null);
  const predvybrano = useRef(false);
  useEffect(() => {
    if (!klientId) return undefined;
    let zivy = true;
    apiFetch(`/api/sales?akce=hovor_klientky&klient_id=${encodeURIComponent(klientId)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (zivy && d && d.hovor) setHovor(d.hovor); })
      .catch(() => {});
    return () => { zivy = false; };
  }, [klientId]);
  // Naplánovaný hovor se jednou předvybere (jen když uživatel ještě nic nezměnil).
  useEffect(() => {
    if (hovor && !predvybrano.current && v.sales === "za3mesice") { predvybrano.current = true; set({ sales: "ponechat" }); }
  }, [hovor]); // eslint-disable-line react-hooks/exhaustive-deps
  const volba = (klic, nadpis, pod) => (
    <button type="button" disabled={disabled} onClick={() => set({ sales: klic })} aria-pressed={v.sales === klic}
      className={`flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left ${v.sales === klic ? "border-2 border-brand bg-brand-50" : "border border-slate-200 bg-white"}`}>
      <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${v.sales === klic ? "border-brand" : "border-slate-300"}`}>{v.sales === klic && <span className="h-2.5 w-2.5 rounded-full bg-brand" />}</span>
      <span className="min-w-0"><span className="block text-sm font-semibold text-slate-900">{nadpis}</span>{pod && (typeof pod === "string" ? <span className="block text-xs text-slate-500">{pod}</span> : <span className="block">{pod}</span>)}</span>
    </button>
  );
  const povinna = v.sales === "nevolat" && v.typ !== "ne_v_dobrem";
  return (
    <div className="mt-3 space-y-3 text-left">
      <div>
        <div className="mb-1.5 text-sm font-semibold text-slate-900">Proč končí?</div>
        <div className="flex flex-wrap gap-1.5">
          {DUVODY_UKONCENI.map((d) => (
            <button key={d.key} type="button" disabled={disabled} onClick={() => set({ duvod: d.key })} aria-pressed={v.duvod === d.key}
              className={`min-h-[40px] rounded-full border px-3 text-sm ${v.duvod === d.key ? "border-brand-900 bg-brand-900 font-semibold text-white" : "border-brand-200 bg-white text-slate-800 hover:border-brand-300"}`}>
              {d.label}
            </button>
          ))}
        </div>
      </div>
      <textarea value={v.poznamka} disabled={disabled} onChange={(e) => set({ poznamka: e.target.value })} rows={2} maxLength={500}
        placeholder={povinna ? "Proč už jí nevolat? (povinné)" : "Poznámka pro sales (nepovinné)"}
        className={`field w-full ${povinna && !String(v.poznamka || "").trim() ? "!border-rose-400" : ""}`} />
      <div>
        <div className="mb-1.5 text-sm font-semibold text-slate-900">Sales</div>
        <div className="space-y-2">
          {hovor && volba("ponechat", "Nechat naplánovaný hovor", <span className="mt-1 inline-flex items-center rounded-full bg-brand px-2.5 py-0.5 text-xs font-bold text-white">Sales jí volá {fmtIso(hovor.datum)}{hovor.cas ? ` v ${String(hovor.cas).slice(0, 5)}` : ""}</span>)}
          {!hovor && volba("za3mesice", "Za 3 měsíce poslat sales k zavolání", datumZa3Mesice(konec))}
          {volba("nevolat", "Už jí nevolat", "")}
        </div>
      </div>
    </div>
  );
}
